export const ACTION_ADD_REVENUES = 'ACTION_ADD_REVENUES';
